import { useEffect, useState } from 'react';
import './PnDisplay.css';
import utils from '../../Functions/utils';

const PnDisplay = (props) => {
  

  const [fName, setFName] = useState('');
  const [motherName, setMotherName] = useState('');
  const [tzedakaAmount, setTzedakaAmount] = useState(0);
  const [tanyaChapters, setTanyaChapters] = useState(0);
  const [keptChitat, setKeptChitat] = useState(true);
  const [error, setError] = useState('');
  const [keptRambam, setkeptRambam] = useState(true);
  

  useEffect(()=>{
    console.log(props.reportData)
    setFName(props.userData.fName)
    setMotherName(props.userData.motherName)
    // setTanyaChapters(10)
    setTanyaChapters(props.reportData.filter(x=>x.chapterId != '001'))
    // setKeptChitat(10)
    // setkeptRambam(10)
    // console.log(props.userData)
  }, [])

  useEffect(() => {
    const fetchData = async () => {
      await fetchUserDeposit();
    };
    fetchData();
  }, []);


  const fetchUserDeposit = async () => {
    try {
      const resp = await utils.requestData('GetUserDeposit', {startDate : props.startDate, endDate : props.endDate});
      const total = resp.reduce((sum, item) => sum + (Number(item.total) || 0), 0);
      // console.log(resp)
      setTzedakaAmount(total)
    } catch (err) {
      console.error('Error fetching userDeposit:', err);
      setError(err.message);
    }
  };



  return (
    <div className="pn-wrapper">
      <h2 className="pn-title">פדיון נפש</h2>

      <p>
        אל כ"ק אדמו"ר,
        <br />
        אנא לעורר רחמים רבים עבור נרנח"י של <br /><strong>{fName} בן {motherName || ''}</strong>.
      </p>

       <p>
          ברצוני לספר לרבי שבתקופה האחרונה<br />
          {tzedakaAmount > 0 && (
            <>
              {' '}
              נתתי <strong>{tzedakaAmount} ש"ח לצדקה</strong>,<br />
            </>
          )}
          {tanyaChapters > 0 && (
            <>
              {' '}
              למדתי כ־<strong>{tanyaChapters} פרקי תניא</strong><br />
            </>
          )}
          {/* {keptChitat && ' שמרתי על חת"ת,'}<br />
          {keptRambam && ' שמרתי על רמב"ם'}<br /> */}
        </p>


      <p>
        אני מבקש בזאת מהרבי ברכה,<br />
        ואני מקבל על עצמי בלי נדר להתחזק בלימוד התורה, קיום המצוות,<br />
        ובהתקשרות פנימית ונאמנה לרבי, נשיא הדור.
      </p>

      <p style={{ marginTop: '2em' }}>
        <strong>{fName} בן {motherName}</strong><br />
      </p>
    </div>
  );
};

export default PnDisplay;
